<template>
  <div class="flex-col group_10 ml-35">
    <steps
      :step="step"
      :data="[
        {src: $images.step1, name: '信息上传' },
        {src: $images.step2, name: '正在审核' },
        {src: $images.step3, name: '申请结果' }
      ]"
    />
    <div class="flex-col mt-9">
      <div v-if="step == 1 || step == 2" class="mt-36 flex-col justify-start relative group_12">
        <div class="section_11"></div>
        <div class="flex-col section_10 pos">
          <div class="flex-row items-center group_13">
            <p class="row">
              <span class="key">公司名称</span>
              <el-input class="value" placeholder="请输入公司名称" v-model="form.name" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">组织机构代码</span>
              <el-input class="value" placeholder="请输入机构代码" v-model="form.zzjg" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">法定代表人姓名</span>
              <el-input class="value" placeholder="请输入代表姓名" v-model="form.frdb" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">公司注册地</span>
              <el-input class="value" placeholder="请输入公司注册地" v-model="form.gszcd" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">办公地址</span>
              <el-input class="value" placeholder="请输入办公地址" v-model="form.bgdz" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">业务范围</span>
              <el-input class="value" placeholder="与合格评定相关的业务范围" v-model="form.ywfw" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">计划开展的服务内容</span>
              <el-input
                type="textarea"
                :rows="5"
                class="value"
                placeholder="以合格评定创新项目为主" v-model="form.fwnr" :disabled="step != 1"></el-input>
            </p>
          </div>
          <div class="flex-row items-center group_13 block2">
            <p class="row">
              <span class="key">申请联系人姓名</span>
              <el-input class="value" placeholder="请输入姓名" v-model="form.lxrxm" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">申请联系人手机号</span>
              <el-input class="value" placeholder="请输入手机号" v-model="form.lxrsjh" :disabled="step != 1"></el-input>
            </p>
            <p class="row">
              <span class="key">申请联系人邮箱</span>
              <el-input class="value" placeholder="请输入邮箱" v-model="form.lxryx" :disabled="step != 1"></el-input>
            </p>
          </div>
        </div>
        <div class="flex-row justify-end self-stretch group_20">
          <!--<div class="flex-row items-center section_13">-->
            <!--<img-->
              <!--class="image_7"-->
              <!--:src="$images.btnSave"-->
            <!--/>-->
            <!--<span class="font_8 ml-9">暂存</span>-->
          <!--</div>-->
          <div v-if="step == 1" class="flex-col justify-start items-center text-wrapper_4 ml-31"  @click="submit"><span class="font_9">完成</span></div>
        </div>
      </div>
      <div v-else class="result-box">
        <img :src="applyImg" alt="img" />
        <div class="box" :class="{success: state == 2}">
          <img :src="state == 2 ? applySuccessIcon : applyFailIcon" alt="" />
          <span class="word">{{state == 2 ? '审核通过' : '审核不通过'}}</span>
          <img class="img" :src="state == 2 ? applySuccess : applyFail" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    const {
      applyImg,
      applyFailIcon,
      applyFail,
      applySuccessIcon,
      applySuccess
    } = this.$images
    return {
      applyImg,
      applyFailIcon,
      applyFail,
      applySuccessIcon,
      applySuccess,
      state: 1, // 审核真实状态
      step: 1,
      business: 1,
      businessOptions: [
        { label: '某某业务', value: 1 }
      ],
      form: {
        name: '', // 公司名称
        zzjg: '', // 组织机构代码
        frdb: '', // 法人代表人姓名
        gszcd: '', // 公司注册地
        bgdz: '', // 办公地址
        ywfw: '', // 业务范围
        fwnr: '', // 计划开展的服务内容
        lxrxm: '', // 申请联系人姓名
        lxrsjh: '', // 申请联系人手机号
        lxryx: '' // 申请联系人邮箱
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      // 获取申请id
      const id = localStorage.getItem('platApplyId')
      if (id) {
        const res = await this.$https.getJgsqDetailById({ id })
        const state = res.data.data.audit_state
        if (state) {
          // 审核状态 1未审核 2审核通过 3审核不通过
          if (['1'].includes(`${state}`)) this.step = 2
          if (['2', '3'].includes(`${state}`)) this.step = 3
          this.state = state
        }
        this.form = res.data.data
      }
    },
    async submit () {
      // const res =
      const res = await this.$https.Jgsq(this.form)
      if (res.data.status) {
        // 申请id缓存
        localStorage.setItem('platApplyId', res.data.data.id)
        this.$message.success('提交成功')
        window.location.reload()
      } else {
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.result-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fafafa;
  padding: 20px 0px;

  .box{
    width: 859px;
    height: 81px;
    line-height: 81px;
    background: #FFF7F9;
    border-radius: 2px;
    border: 2px solid #FDCAD7;
    margin-top: 15px;
    position: relative;
    padding-left: 32px;
    font-family: PingFang;
    font-weight: bold;
    font-size: 18px;
    color: #666666;

    display: flex;
    flex-direction: row;
    align-items: center;

    &.success{
      background: #F7FBFF;
      border: 2px solid #CAE3FD;
    }

    .word{
      margin-left: 10px;
    }

    .img{
      position: absolute;
      right: 17px;
      top: -33px;
    }
  }
}
  .group_10 {
    margin-top: 37px;
    width: 1076px;
    .group_11 {
      padding: 0 142px;
      .image_2 {
        width: 64px;
        height: 65px;
      }
      .image_4 {
        width: 253px;
        height: 2px;
      }
      .image_3 {
        width: 65px;
        height: 65px;
      }
    }
    .text_16 {
      margin-left: 143px;
      line-height: 16px;
      margin-top: 9px;
    }
    .text_17 {
      line-height: 16px;
      margin-left: 8px;
      margin-top: 9px;
    }
    .text_18 {
      margin-right: 143px;
      position: relative;
      left: 9px;
      margin-top: 9px;
    }
    .group_12 {
      padding: 5px 0 22px;
      .section_10 {
        // padding: 38px 25px 0px 31px;
        .group_13 {
          display: flex;
          flex-direction: column;
          background-color: #fafafa;

          &:nth-child(1) {
            padding-top: 38px;
            padding-right: 25px;
            padding-bottom: 142px;
            padding-left: 31px;
          }

          &.block2{
            margin-top: 15px;
            padding-top: 38px;
            padding-right: 25px;
            padding-bottom: 45px;
            padding-left: 31px;
          }

          .row{
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin-top: 0px;

            .key{
              width: 148px;
              text-align: right;
            }

            .value{
              width: 537px;
              height: 35px;
              margin-left: 10px;

              /deep/ input{
                height: 35px;
                line-height: 35px;
                border: 2px solid #CAE3FD;
              }

              /deep/ textarea{
                font-family: Arial;
                width: 859px;
                border: 2px solid #CAE3FD;
                resize: none;
              }
            }
          }
        }
        .group_14 {
          margin-top: 19px;
          padding: 0 49px;
        }
        .text-wrapper_2 {
          padding: 10px 0;
          border-radius: 2px;
          background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=ef687600ce72699cda5051aff902c3ea.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          width: 538px;
          height: 36px;
          .text_20 {
            margin-left: 19px;
          }
        }
        .group_15 {
          margin-top: 18px;
          padding: 0 33px;
        }
        .group_16 {
          margin-top: 19px;
          padding: 0 64px;
        }
        .group_17 {
          padding: 0 81px;
          .image-wrapper {
            padding: 17px 0 14px;
            border-radius: 2px;
            background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=ef687600ce72699cda5051aff902c3ea.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            width: 538px;
            height: 36px;
            .image_5 {
              margin-right: 15px;
              width: 9px;
              height: 5px;
            }
          }
        }
        .view {
          margin-top: 18px;
        }
        .view_2 {
          margin-top: 19px;
        }
        .group_18 {
          margin-top: 25px;
          .text_21 {
            margin-top: 8px;
          }
          .image_6 {
            border-radius: 2px;
            width: 861px;
            height: 114px;
          }
        }
      }

    }
  }
  .font_7 {
    font-size: 15px;
    font-family: PingFang;
    line-height: 15px;
    color: #999999;
  }
  .section_12 {
    margin-right: 244px;
    padding: 39px 48px 44px;
    background-color: #fafafa;
    .group_19 {
      padding: 0 17px;
      .text_22 {
        line-height: 16px;
      }
    }
    .text-wrapper_3 {
      padding: 10px 0;
      border-radius: 2px;
      background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=c97a8fef57de3b6c3dd79ee9fbfdce0a.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 538px;
      height: 36px;
      .text_23 {
        margin-left: 19px;
        line-height: 16px;
      }
      .text_24 {
        margin-left: 19px;
      }
    }
  }
  .group_20 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 10;
    margin-top: 40px;
    .section_13 {
      padding: 8px 14px;
      background-color: #0071d6;
      border-radius: 2px;
      width: 94px;
      height: 32px;
      cursor: pointer;
      .image_7 {
        width: 17px;
        height: 16px;
      }
    }
    .text-wrapper_4 {
      padding: 8px 0;
      background-color: #0071d6;
      border-radius: 2px;
      width: 94px;
      height: 32px;
      margin-left: 32px;
      cursor: pointer;
    }
    .font_8 {
      font-size: 13px;
      font-family: Alibaba;
      letter-spacing: 2.5px;
      color: #ffffff;
      margin-left: 9px;
    }
    .font_9 {
      font-size: 13px;
      font-family: Alibaba;
      letter-spacing: 2.5px;
      color: #ffffff;
    }
  }
</style>
